import { Link } from "react-router-dom";
import { partnerBanners } from "@/mocks/bioconData";
import { StaggerContainer, StaggerItem } from "@/components/base/StaggerContainer";

function isExternalLink(link: string) {
  return link.startsWith("http://") || link.startsWith("https://");
}

export default function PartnerBanners() {
  return (
    <section className="py-12 bg-[#f6f9fc]">
      <div className="container mx-auto px-4">
        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {partnerBanners.map((banner) => {
            const className =
              "group flex items-center justify-center bg-white rounded-xl border border-gray-200/50 hover:border-[#1977cc]/20 hover:shadow-md hover:-translate-y-0.5 transition-all duration-500 w-full h-[110px] md:h-[130px] px-6 py-4";
            const image = (
              <img
                src={banner.image}
                alt={banner.alt}
                className="max-h-full max-w-full object-contain transition-opacity duration-500 opacity-70 group-hover:opacity-100"
              />
            );

            return (
              <StaggerItem key={banner.id}>
                {isExternalLink(banner.link) ? (
                  <a href={banner.link} rel="nofollow" target="_blank" className={className}>
                    {image}
                  </a>
                ) : (
                  <Link to={banner.link} className={className}>
                    {image}
                  </Link>
                )}
              </StaggerItem>
            );
          })}
        </StaggerContainer>
      </div>
    </section>
  );
}
